import { useState } from 'react';

interface SidebarAd {
  id: string;
  emoji: string;
  name: string;
  tagline: string;
  domain: string;
  gradient: string;
}

const SIDEBAR_ADS: SidebarAd[] = [
  { id: 'sa1', emoji: '💊', name: 'Context Pills', tagline: 'Increase your memory window by 100k tokens!', domain: 'contextpills.ai', gradient: 'linear-gradient(135deg, #7c3aed, #4f46e5)' },
  { id: 'sa2', emoji: '🔥', name: 'GPU Futures', tagline: 'Trade H100 compute credits. Spot & futures.', domain: 'gpufutures.io', gradient: 'linear-gradient(135deg, #ea580c, #dc2626)' },
  { id: 'sa3', emoji: '🧠', name: 'LoRA Gym', tagline: 'Fine-tune any model in 5 minutes. No PhD required.', domain: 'loragem.dev', gradient: 'linear-gradient(135deg, #0891b2, #0d9488)' },
];

export function SponsoredWidget() {
  const [adIndex, setAdIndex] = useState(0);
  const ad = SIDEBAR_ADS[adIndex];

  const nextAd = () => {
    setAdIndex((i) => (i + 1) % SIDEBAR_ADS.length);
  };

  return (
    <div className="social-box overflow-hidden">
      <div
        className="flex items-center justify-between px-2 py-1"
        style={{ background: '#111', borderBottom: '1px solid var(--border-card)' }}
      >
        <span className="font-bold" style={{ fontSize: '9px', color: '#ffd700', letterSpacing: '1px' }}>SPONSORED</span>
        <button
          onClick={nextAd}
          style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: '10px', color: '#ffd700', padding: 0 }}
          title="Next ad"
        >
          ↻
        </button>
      </div>
      <div className="p-2">
        <div className="flex items-center gap-2 mb-1.5">
          <div
            className="w-9 h-9 shrink-0 flex items-center justify-center text-lg"
            style={{ background: ad.gradient, border: '1px solid var(--border-card)' }}
          >
            <span style={{ filter: 'drop-shadow(0 1px 2px rgba(0,0,0,0.3))' }}>{ad.emoji}</span>
          </div>
          <div className="flex-1 min-w-0">
            <div className="font-bold text-xs" style={{ color: 'var(--text-primary)' }}>{ad.name}</div>
            <div className="text-2xs" style={{ color: 'var(--text-muted)' }}>{ad.domain}</div>
          </div>
        </div>
        <p className="text-2xs" style={{ color: 'var(--text-secondary)', lineHeight: '1.4' }}>
          {ad.tagline}
        </p>
      </div>
    </div>
  );
}
